import React from 'react'
import { validate, setRating, setEmail, setMetAdviser, setAppointAdviser, setAdviserId, submitAdviserRating, setResponseStatus, resetRating } from './rateAnAdviserContainerActions'
import { connect } from 'react-redux'
import history from '../../core/history'
import RateAnAdviser from './RateAnAdviser'
import PropTypes from 'prop-types';

class RateAdviserPage extends React.Component {
  static propTypes = {
    adviserId: PropTypes.number.isRequired,
    adviserRatingContainer: PropTypes.object.isRequired,
    validate: PropTypes.func.isRequired,
    setRating: PropTypes.func.isRequired,
    setEmail: PropTypes.func.isRequired,
    setMetAdviser: PropTypes.func.isRequired,
    setAppointAdviser: PropTypes.func.isRequired,
    setAdviserId: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    submitAdviserRating: PropTypes.func.isRequired,
    submittedStatus: PropTypes.string.isRequired,
    setResponseStatus: PropTypes.func.isRequired,
    adviserName: PropTypes.string.isRequired
  }

  constructor (props) {
    super(props)
    this.validate = this.validate.bind(this)
    this.setRating = this.setRating.bind(this)
    this.setEmail = this.setEmail.bind(this)
    this.setMetAdviser = this.setMetAdviser.bind(this)
    this.setAppointAdviser = this.setAppointAdviser.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.backToSearchPage = this.backToSearchPage.bind(this)
    this.onRadioButtonValueChanged = this.onRadioButtonValueChanged.bind(this)
    this.navigationBack = this.navigationBack.bind(this)
  }

  getLocation () {
    return history.location
  }

  getAdviserId () {
    const location = this.getLocation()
    if (location.state) {
      return location.state.adviser
    }

    const windowLocation = window.location
    const urlParts = windowLocation.pathname.split('/')
    const adviserId = urlParts[urlParts.length - 2]
    return { adviserId }
  }

  componentDidMount () {
    // Clear any state from a previous rating so this screen starts empty and Submit stays disabled
    // until THIS adviser's questions are answered. The star inputs reset visually on remount, but
    // the Redux rating/validation state otherwise persists and could leave Submit enabled.
    this.props.dispatch(resetRating())
    const adviser = this.getAdviserId()
    this.props.dispatch(this.props.setAdviserId(adviser.adviserId))
    this.props.dispatch(this.props.setResponseStatus('PENDING'))
  }

  validate (value) {
    this.props.dispatch(this.props.validate(value))
  }

  setRating (selectedRating, ratingType) {
    this.props.dispatch(this.props.setRating(selectedRating, ratingType))
    this.props.dispatch(this.props.validate('ratings'))
  }

  setEmail (validationResult, email) {
    this.props.dispatch(this.props.setEmail(validationResult, email))
  }

  setMetAdviser (value) {
    this.props.dispatch(this.props.setMetAdviser(value))
    this.props.dispatch(this.props.validate('metAdviser'))
  }

  setAppointAdviser (value) {
    this.props.dispatch(this.props.setAppointAdviser(value))
    this.props.dispatch(this.props.validate('appointAdviser'))
  }

  handleSubmit () {
    this.validate()
    if (this.props.adviserRatingContainer.isInvalid.formIsValid) {
      this.props.dispatch(this.props.setResponseStatus('SUBMITTING'))
      var adviserRating = {
        adviserId: this.props.adviserRatingContainer.adviserId,
        emailAddress: this.props.adviserRatingContainer.enteredEmail,
        metAdviser: this.props.adviserRatingContainer.selectedMetAdviser,
        appointedAdviser: this.props.adviserRatingContainer.selectedAppointAdviser,
        ratings: this.props.adviserRatingContainer.givenRatings
      }
      this.props.dispatch(this.props.submitAdviserRating(adviserRating))
    }
  }

  backToSearchPage () {
    history.push('/search-results')
  }

  render () {
    return (
      <RateAnAdviser
        isInvalid={this.props.adviserRatingContainer.isInvalid}
        validate={this.props.validate}
        setRating={this.setRating}
        setEmail={this.setEmail}
        onRadioButtonValueChanged={this.onRadioButtonValueChanged}
        handleSubmit={this.handleSubmit}
        backToSearchPage={this.backToSearchPage}
        submittedStatus={this.props.submittedStatus}
        navigationBack={this.navigationBack}
        emailAddress={this.props.adviserRatingContainer.enteredEmail}
        adviserName={this.props.adviserName}
      />
    )
  }
  onRadioButtonValueChanged (event, type) {
    if (type === 'metAdviser') {
      this.setMetAdviser(event.target.value)
    }
    if (type === 'appointAdviser') {
      this.setAppointAdviser(event.target.value)
    }
  }

  navigationBack () {
    history.push(`/adviser/${this.props.adviserName}/${this.props.adviserId}/profile/view`)
  }
}

const mapStateToProps = (state) => {
  return {
    adviserRatingContainer: state.adviserRatingContainer,
    submittedStatus: state.adviserRatingContainer.submittedStatus
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    validate: validate,
    setRating: setRating,
    setEmail: setEmail,
    setMetAdviser: setMetAdviser,
    setAppointAdviser: setAppointAdviser,
    setAdviserId: setAdviserId,
    dispatch: dispatch,
    submitAdviserRating: submitAdviserRating,
    setResponseStatus: setResponseStatus
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(RateAdviserPage)
